import { useCallback, useState, useMemo } from 'react';
import { Modal, ModalProps } from 'react-bootstrap';
import { AdvisorModel } from '@/lib/models';
import { createUseThemedStyles } from '@/hooks';
import { accountService } from '@/lib/services';
import { AuthorsList, SearchInput } from '@/components';

const useStyles = createUseThemedStyles({
	dialog: {
		width: '90%',
		height: '100%',
		maxWidth: 750,
		margin: '0 auto',
		'& .modal-content': {
			maxHeight: '90vh',
		},
		'& .hackett-modal__body': {
			overflowY: 'auto',
		},
	},
});

interface BlogAuthorModelProps extends ModalProps {
	authors: AdvisorModel[];
	onChange(authors: AdvisorModel[]): void;
}

export const BlogFollowModel = ({ authors, onChange, ...props }: BlogAuthorModelProps) => {
	const classes = useStyles();
	const [searchValue, setSearchValue] = useState('');

	const fetchData = useCallback(async () => {
      const { authors } = await accountService.getAlertPreferences().fetch();
      onChange(authors);
    }, [onChange]);

	const filteredAuthors = useMemo(() => {
		if (!searchValue.trim()) return authors;
		return authors.filter(author => author.name.toLowerCase().includes(searchValue.toLowerCase()));
	}, [authors, searchValue]);

	return (
		<Modal dialogClassName={classes.dialog} centered {...props}>
			<Modal.Header closeButton>
				<Modal.Title>Authors in Your Program(s)</Modal.Title>
			</Modal.Header>
			<Modal.Body >
				<SearchInput
					value={searchValue}
					onChange={({ currentTarget }) => {
						setSearchValue(currentTarget.value);
					}}
					className="mb-3"
				/>
				<AuthorsList
					authors={filteredAuthors}
					onAfterFollowToggle={fetchData}
					showOnlyList
				/>
			</Modal.Body>
		</Modal>
	);
};
